// Tooltip Styles

import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { customMedia } from 'styles/utils';

export const TooltipStyled = styled(ReactTooltip)`
  &&& {
    background: ${props => props.theme.color.wfBlack};
    max-width: 220px;
    padding: ${props =>
      `${props.theme.spacing.xsmall} ${props.theme.spacing.small}`};
    border-radius: 0;
    font-family: ${props => props.theme.font.family.primary};
    font-size: ${props => props.theme.font.size.small};
    text-align: center;
    line-height: ${props => props.theme.font.lineHeight.medium};
    opacity: 1;
    &::after {
      color: ${props => props.theme.color.wfBlack};
    }
    //&.place-bottom::after {
    //  border-bottom-color: currentColor;
    //}
    //&.place-top::after {
    //  border-top-color: currentColor;
    //}
    //&.place-bottom::after,
    //&.place-top::after {
    //  border-width: 5px;
    //  margin-left: -5px;
    //}
    //&.place-right::after {
    //  border-right-color: currentColor;
    //}
    //&.place-left::after {
    //  border-left-color: currentColor;
    //}
    //&.place-right::after,
    //&.place-left::after {
    //  margin-top: -5px;
    //}
  }

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;
